import { render, staticRenderFns } from "./WootButton.vue?vue&type=template&id=72500979&scoped=true&"
import script from "./WootButton.vue?vue&type=script&lang=js&"
export * from "./WootButton.vue?vue&type=script&lang=js&"
import style0 from "./WootButton.vue?vue&type=style&index=0&id=72500979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72500979",
  null
  
)

export default component.exports